import React, { useCallback } from 'react';
import { IWizardStep } from '../Wizard/WizardBreadCrumbButton';
import styles from './mobileWizardBreadcrumb.module.scss';
import { buildClassNames } from '@ui/utils/classNameUtils';
import { BreadCrumbStatus } from '@ui/components/WizardV2/WizardBreadCrumbButton/WizardBreadCrumbButton';
import { getStatus } from '@ui/components/WizardV2/WizardBreadCrumb/WizardBreadCrumb';

export interface IProps {
    /**
     * Шаги визарда
     */
    steps: IWizardStep[];
    /**
     * Индекс текущего шага
     */
    currentStepIndex: number;
    /**
     * @event
     * Событие, которое срабатывает при выборе одного из шагов визарда
     * @param stepId - id шага, который был выбран
     */
    onSelect?: (stepId: number) => void;
    /**
     * Функция, возвращающая флаг кликабельности шага
     * @param step - шаг
     * @param disableNavigation - флаг отключения навигации по шагам визарда
     */
    getIsClickable: (step: IWizardStep, disableNavigation?: boolean) => boolean;
    /**
     * Флаг отключения навигации по шагам визарда
     */
    disableNavigation?: boolean;
    /**
     * Id текущего шага
     */
    currentStageId?: number;
}

/**
 * Breadcrumb для мобильного визарда
 */
export default function MobileWizardBreadcrumb({
    steps,
    currentStepIndex,
    onSelect,
    getIsClickable,
    currentStageId,
    disableNavigation,
}: IProps) {
    const currentStep = steps[currentStepIndex];

    const getStepContainerClassName = useCallback((status: BreadCrumbStatus, clickable: boolean) => buildClassNames(styles, [
        'step',
        `step--${status ?? BreadCrumbStatus.Default}`,
        clickable && 'step--clickable',
    ]), []);

    return (
        <div className={styles['container']}>
            <h3 className={styles['title']}>{currentStep.title}</h3>
            <div className={styles['steps-container']}>
                {steps?.map(step => (
                    <button
                        key={step.id}
                        type="button"
                        className={getStepContainerClassName(getStatus(step.type), getIsClickable(step, disableNavigation))}
                        onClick={() => onSelect?.(step.id)}
                        disabled={!getIsClickable(step, disableNavigation)}
                    />
                ))}
            </div>
        </div>
    );
};
